import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-firma',
  templateUrl: './firma.component.html',
  styleUrls: ['./firma.component.css']
})
export class FirmaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  firmar(){

  }


}
